/**
 * 系統把資料儲存到 LocalStorage 內用的 key 值。
 */
export enum SystemLocalStorage {
  JWT_TOKEN = 'jwtToken',
  USER_PROFILE = 'userProfile',
  SIDEBAR_MENUS = 'sidebarMenus',
  REDIRECT_URL = 'redirectUrl',
  QUERY_PARAMS = 'queryParams',
  REFRESH_TOKEN = 'refreshToken'
}
